export default __webpack_public_path__ + "static/media/canine-tooth.f85e07ad.svg";